export enum KeyManager {
  Mobile = 'mobile',
  Native = 'native',
  KeepKey = 'keepkey',
  MetaMask = 'metamask',
  TallyHo = 'tallyho',
  Portis = 'portis',
  Demo = 'demo',
  WalletConnect = 'walletconnect',
  XDefi = 'xdefi',
  Keplr = 'keplr',
}
